module.exports = __webpack_public_path__ + "img/tab2.8cbe10ee.svg";